import React from 'react'

export default function Alert(props) {
    return (
        <div className={`alert alert-${props.type} alert-dismissible fade show`} role="alert" style={{marginTop:'2px', marginLeft:'2px', marginRight:'2px'}}>
            {props.children}
            <button hidden={props.hidden} onClick={props.onCloseAlert} type="button" className="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">×</span>
            </button>
        </div>
    )
}
